import React from 'react';
import {
  BooleanInput,
} from 'react-admin';

import {
  Box,
  Card,
  Typography,
} from '@mui/material';

import { OutputSheet } from '../../constants/reportMetadata';
import InfoPopover from '../layout/InfoPopover';
import AccordionV2, { AccordionRow } from '../layout/AccordionV2';

// Gap between checkbox and label in Material UI spacing units (1.5 = 12px)
const COLUMN_CHECKBOX_LABEL_GAP = 1.5;

const ReportOutputConfiguration = ({ outputSheets }: { outputSheets: OutputSheet[] }) => (
  <Card variant="outlined">
    {outputSheets.map((sheet) => (
      <AccordionV2
        key={sheet.name}
        title={(
          <Typography color="primary">
            {`Sheet: ${sheet.name}`}
          </Typography>
        )}
        bgColorSummary="greenGray"
      >
        {sheet.columns.length > 0 && (
          <AccordionV2 title="Columns">
            {sheet.columns.map((col) => (
              <AccordionRow key={col.id}>
                <Box
                  data-testid={`output-column-row-${sheet.id}-${col.id}`}
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  gap={COLUMN_CHECKBOX_LABEL_GAP}
                >
                  <BooleanInput
                    source={`outputConfig.${sheet.id}.columns.${col.id}`}
                    label=""
                    helperText={false}
                    sx={{ margin: 0 }}
                    readOnly={col.isDynamic || col.isRequired}
                  />
                  <Box
                    data-testid={`output-column-label-${sheet.id}-${col.id}`}
                    display="flex"
                    alignItems="center"
                  >
                    <Typography>{col.name}</Typography>
                    <InfoPopover title={col.name} content={col.description} />
                  </Box>
                </Box>
              </AccordionRow>
            ))}
          </AccordionV2>
        )}
        {sheet.rows.length > 0 && (
          <AccordionV2 title="Rows">
            {sheet.rows.map((row) => (
              <AccordionRow key={row.id}>
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <Typography>{row.name}</Typography>
                    <InfoPopover title={row.name} content={row.description} />
                  </Box>
                  <BooleanInput
                    source={`outputConfig.${sheet.id}.rows.${row.id}`}
                    label=""
                    helperText={false}
                    readOnly
                  />
                </Box>
              </AccordionRow>
            ))}
          </AccordionV2>
        )}
      </AccordionV2>
    ))}
  </Card>
);

export default ReportOutputConfiguration;
